module.exports = __webpack_public_path__ + "img/comingSon.8f535ef8.svg";